<template is-multiline>
  <section class="section has-text-dark has-background-white">
    <div class="container">
      <h1>{{model.Title}}</h1>
      <form @submit.prevent="validateBeforeSubmit('register-sme')" data-vv-scope="register-sme">
        <label class="label required">NCCN Program Benefits</label>
        <div v-html="labels.nCCNProgramBenefitsDescriptionLabel"></div>
        <p class="control has-icon has-icon-right mb-0">
          <label class="checkbox">
            <input name="benefits" v-model="model.NCCNProgramBenefits" type="checkbox" v-validate="'required'">
            {{labels.nCCNProgramBenefitsLabel}}
          </label>
        </p>
        <i v-show="errors.has('register-sme.benefits')" class="fa fa-warning"></i>
        <span class="help is-danger" v-show="errors.has('register-sme.benefits')">The program benefits field is required.</span>
         <br />
        <label class="label required">NCCN SME Participant Commitments</label>
        <div v-html="labels.NCCNSMEParticipantCommitmentsLabel"></div>
        <p class="control has-icon has-icon-right mb-0">
          <ul id="commitments">
            <li v-for="item in model.NCCNSMEParticipantCommitments" :key="item.Text">
              <label class="checkbox">
                <input name="commitment" v-model="item.Selected" type="checkbox" v-validate="'required'">
                {{item.Text}}
              </label>
            </li>
          </ul>
          <i v-show="errors.has('register-sme.commitment') || selectAll" class="fa fa-warning"></i>
          <span class="help is-danger" v-show="errors.has('register-sme.commitment') || selectAll">Please agree to all three commitments</span>
        </p>

        <div class="columns mt-5">
          <div class="column is-5">
            <div class="field">
              <label class="label required">{{labels.phoneOrMobileNumberLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="phone" v-model="model.Phone" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register-sme.phone') || phoneInValid}" type="text">
                <i v-show="errors.has('register-sme.phone') || phoneInValid" class="fa fa-warning"></i>
                <span v-show="errors.has('register-sme.phone')" class="help is-danger">The phone number field is required.</span>
                <span v-show="phoneInValid" class="help is-danger">The phone field may only contain numeric characters, spaces, and the following characters ( ) and + </span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.genderLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="genders">
                  <li v-for="item in model.GenderList" :key="item.Text">
                    <label class="radio">
                      <input name="gender" v-bind:value="item.Text" v-model="model.Gender" type="radio" v-validate="'required'" :class="{'is-danger': errors.has('register-sme.gender') }">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-sme.gender')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-sme.gender')">{{errors.first('register-sme.gender')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.ethnicityLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="ethnicities">
                  <li v-for="item in model.EthnicityList" :key="item.Text">
                    <label class="checkbox">
                      <input name="ethnicity" v-model="item.Selected" type="checkbox" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-sme.ethnicity')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-sme.ethnicity')">{{errors.first('register-sme.ethnicity')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.attendingDialogListLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="dialogs">
                  <li v-for="item in model.AttendingDialogList" :key="item.Text">
                    <label class="radio">
                      <input name="dialog" v-bind:value="item.Text" v-model="model.Dialog" type="radio" v-validate="'required'">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-sme.dialog')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-sme.dialog')">An answer Yes or No is required</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.subjectAreaLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="subjects">
                  <li v-for="item in model.SubjectAreaList" :key="item.Text">
                    <label class="radio">
                      <input name="subject" v-bind:value="item.Text" v-model="model.Subject" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text,'Subject')">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <input v-bind:required="isRequired(isOtherSubjectActive)" v-bind:disabled="isDisabled(isOtherSubjectActive)" name="subject" v-model="model.OtherSubject" type="text" :class="{'input': true, 'is-danger': errors.has('register-sme.subject') }" />
                <i v-show="errors.has('register-sme.subject')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-sme.subject')">{{errors.first('register-sme.subject')}}</span>
              </p>
            </div>
            <div class="field">
              <div class="field">
                <label class="label required">{{labels.workLabelLabel}}</label>
                <p class="control has-icon has-icon-right">
                  <ul id="works">
                    <li v-for="item in model.WorkList" :key="item.Text">
                      <input name="work" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Work')">
                      {{item.Text}}
                    </li>
                  </ul>
                  <input v-bind:required="isRequired(isOtherWorkActive)" v-bind:disabled="isDisabled(isOtherWorkActive)" name="work" v-model="model.OtherWork" type="text" :class="{'input': true, 'is-danger': errors.has('register-sme.work') }" />
                  <i v-show="errors.has('register-sme.work')" class="fa fa-warning"></i>
                  <span class="help is-danger" v-show="errors.has('register-sme.work')">{{errors.first('register-sme.work')}}</span>
                </p>
              </div>
            </div>
            <div class="field">
              <label class="label required">{{labels.professionalRolesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="roles">
                  <li v-for="item in model.ProfessionalRolesList" :key="item.Text">
                    <label class="checkbox">
                      <input name="role" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Role')">
                      {{item.Text}}
                    </label>
                  </li>
                </ul>
                <i v-show="errors.has('register-sme.role')" class="fa fa-warning"></i>
                <input :required="{isOtherProfessionalRoleActive :'required'}" v-bind:disabled="isDisabled(isOtherProfessionalRoleActive)" name="role" v-model="model.OtherProfessionalRole" type="text" :class="{'input': true, 'is-danger': errors.has('register-sme.role') }" />
                <span class="help is-danger" v-show="errors.has('register-sme.role')">{{errors.first('register-sme.role')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.yourMainResearchFocusLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="research" v-model="model.YourMainResearchFocus" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('register-sme.research') }" type="text">
                <i v-show="errors.has('register-sme.research')" class="fa fa-warning"></i>
                <span v-show="errors.has('register-sme.research')" class="help is-danger">{{errors.first('register-sme.research')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.educationPublicExperienceLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="experiences">
                  <li v-for="item in model.ExperienceList" :key="item.Text">
                    <input name="experience" v-bind:value="item.Text" v-model="model.Experience" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text,'Experience')">
                    {{item.Text}}
                  </li>
                </ul>
                <input v-bind:required="isRequired(isOtherExperienceActive)" v-bind:disabled="isDisabled(isOtherExperienceActive)" name="experience" v-model="model.OtherExperience" type="text" :class="{'input': true, 'is-danger': errors.has('register-sme.experience') }" />
                <i v-show="errors.has('register-sme.experience')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-sme.experience')">{{errors.first('register-sme.experience')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label">{{labels.educationPublicEngagementExperienceDetailsLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="details" v-model="model.EducationPublicEngagementExperienceDetails" :class="{'input': true, 'is-danger': errors.has('register-sme.details') }" type="text">
              </p>
            </div>
            <div class="field">
              <label class="label required">{{labels.classesLabel}}</label>
              <p class="control has-icon has-icon-right">
                <ul id="classes">
                  <li v-for="item in model.ClassList" :key="item.Text">
                    <input name="class" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Class')">
                    {{item.Text}}
                  </li>
                </ul>
                <input v-bind:required="isRequired(isOtherClassActive)" v-bind:disabled="isDisabled(isOtherClassActive)" name="class" v-model="model.OtherClass" type="text" :class="{'input': true, 'is-danger': errors.has('register-sme.class') }" />
                <i v-show="errors.has('register-sme.class')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('register-sme.class')">{{errors.first('register-sme.class')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label">{{labels.yourInterestLabel}}</label>
              <p class="control has-icon has-icon-right">
                <input name="interest" v-model="model.YourInterest" :class="{'input': true, 'is-danger': errors.has('register-sme.interest') }" type="text">
                <i v-show="errors.has('register-sme.interest')" class="fa fa-warning"></i>
                <span v-show="errors.has('register-sme.interest')" class="help is-danger">{{errors.first('register-sme.interest')}}</span>
              </p>
            </div>
            <div class="field">
              <label class="label">{{labels.bioLabel}}</label>
              <p class="control has-icon has-icon-right">
                <textarea name="bio" v-model="model.Bio" :class="{'input': true, 'is-danger': errors.has('register-cci.bio') }" type="text"> </textarea>
              </p>
            </div>
            <div class="field">
              <p class="control">
                <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Submit</button>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>

  export default {
    name: 'registerSME',
    data() {
      return {
        model: {
        },
        errored: false,
        labels: [],
        isOtherSubjectActive: false,
        isOtherWorkActive: false,
        isOtherExperienceActive: false,
        isOtherClassActive: false,
        isOtherCommitmentActive: false,
        isOtherProfessionalRoleActive: false,
        loading: false

      }
    },
    computed: {
      phoneInValid() {
        return !(!this.model.Phone || /^\s*$/.test(this.model.Phone)) && /^(?=.*[0-9])[+()0-9\s]+$/.test(this.model.Phone) == false;
      },
      selectAll() {
        if (this.model.NCCNSMEParticipantCommitments && this.model.NCCNSMEParticipantCommitments.some(item => item.Selected))
                this.errored = this.model.NCCNSMEParticipantCommitments.some(item => !item.Selected);
        return this.errored;
      }
    },
    created() {
      if (localStorage.getItem("sme-application-submission") != null && localStorage.getItem("sme-application-submission") == this.$route.query.id) {
        localStorage.removeItem('sme-application-submission');
        window.location.href = "/register/application-submission/";
      }
      this.$http
        .get('/umbraco/surface/RegisterSurface/RegisterSME')
        .then(response => {
          if (response.data.redirectURL) {
            window.location.href = response.data.redirectURL;
          }
          else {
            this.model = response.data.model;
            this.labels = response.data.labels;
            this.model.RegistrationId = this.$route.query.id;
            this.loading = false;
            if (this.model.OtherSubject)
              this.isOtherSubjectActive = true;
            if (this.model.OtherWork)
              this.isOtherWorkActive = true;
            if (this.model.OtherExperience)
              this.isOtherExperienceActive = true;
            if (this.model.OtherProfessionalRole)
              this.isOtherProfessionalRoleActive = true;
            if (this.model.OtherClass)
              this.isOtherClassActive = true;
          }
        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmit(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/RegisterSurface/PostRegisterSME',
                this.model
              )
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else if (response.data.redirectURL) {
                  this.loading = false;
                  window.location.href = response.data.redirectURL;
                  localStorage.setItem("sme-application-submission",this.$route.query.id);
                }
              })
              .catch(function (error) {
              });
            return;
          }
          else {

            $('html, body').animate({
              scrollTop: ($('.is-danger:visible').offset().top - 100)
            }, 500);

            return;
          }

        });
      },
      isLetterOrNumber(e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[A-Za-z0-9]+$/.test(char)) return true;
        else e.preventDefault();
      },
      checkOthers(value, type) {
        switch (type) {
          case "Subject":
            if (value == "Other:")
              this.isOtherSubjectActive = true;
            else {
              this.isOtherSubjectActive = false;
              this.model.OtherSubject = "";
            }
            break;
          case "Work":
            if (value == "Other:") {
              if (this.isOtherWorkActive) {
                this.isOtherWorkActive = false;
                this.model.OtherWork = "";
              }
              else
                this.isOtherWorkActive = true;
            }
            else
            break;
          case "Experience":
            if (value == "Other:")
              this.isOtherExperienceActive = true;
            else {
              this.isOtherExperienceActive = false;
              this.model.OtherExperience = "";
            }
            break;
          case "Role":
            if (value == "Other:") {
              if (this.isOtherProfessionalRoleActive) {
                this.isOtherProfessionalRoleActive = false;
                this.model.OtherProfessionalRole = "";
              }
              else
                this.isOtherProfessionalRoleActive = true;
            }
            break;
          case "Class":
            if (value == "Other:") {
              if (this.isOtherClassActive) {
                this.isOtherClassActive = false;
                this.model.OtherClass = "";
              }
              else
                this.isOtherClassActive = true;
            }
            break;

        }

      },

      isDisabled(value) {
        return value ? null : "disabled";
      },
      isRequired(value) {
        return value ? true : false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/RegisterSME.vue